import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../utils/api';
import EditorialPanel from '../../components/admin/EditorialPanel';
import CollectionsPanel from '../../components/admin/CollectionsPanel';
import TestimonialsPanel from '../../components/admin/TestimonialsPanel';
import FAQPanel from '../../components/admin/FAQPanel';
import SubmissionsPanel from '../../components/admin/SubmissionsPanel';
import SettingsPanel from '../../components/admin/SettingsPanel';
import PhotoSettingsPanel from '../../components/admin/PhotoSettingsPanel';
import PhotoPageContentPanel from '../../components/admin/PhotoPageContentPanel';
import FilmSettingsPanel from '../../components/admin/FilmSettingsPanel';
import FilmLandingPanel from '../../components/admin/FilmLandingPanel';
import AboutSettingsPanel from '../../components/admin/AboutSettingsPanel';
import ServicesPanel from '../../components/admin/ServicesPanel';
import BlogPanel from '../../components/admin/BlogPanel';
import CrystalDifferencePanel from '../../components/admin/CrystalDifferencePanel';
import ApiAccessPanel from '../../components/admin/ApiAccessPanel';
import SecurityPanel from '../../components/admin/SecurityPanel';
import InspoPanel from '../../components/admin/InspoPanel';
import ViewAnalyticsPanel from '../../components/admin/ViewAnalyticsPanel';
import SeoPagesPanel from '../../components/admin/SeoPagesPanel';
import VendorsPanel from '../../components/admin/VendorsPanel';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('photo-settings');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await api.verifyToken();
        setLoading(false);
      } catch (err) {
        navigate('/');
      }
    };
    verifyAuth();
  }, [navigate]);

  const handleLogout = () => {
    api.clearToken();
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  const tabs = [
    { id: 'photo-settings', label: 'Photo Settings', group: 'Photo' },
    { id: 'photo-page-content', label: 'Photo Page', group: 'Photo' },
    { id: 'collections', label: 'Collections', group: 'Photo' },
    { id: 'film-settings', label: 'Film Theatre', group: 'Film' },
    { id: 'film-landing', label: 'Film Landing', group: 'Film' },
    { id: 'crystal-difference', label: 'Crystal Difference', group: 'Film' },
    { id: 'services', label: 'Services', group: 'Content' },
    { id: 'blog', label: 'Blog', group: 'Content' },
    { id: 'inspo', label: 'Inspo Grid', group: 'Content' },
    { id: 'seo-pages', label: 'SEO Pages', group: 'Content' },
    { id: 'vendors', label: 'Vendors', group: 'Content' },
    { id: 'about-settings', label: 'About & Inquire', group: 'Pages' },
    { id: 'testimonials', label: 'Testimonials', group: 'Pages' },
    { id: 'faqs', label: 'FAQs', group: 'General' },
    { id: 'submissions', label: 'Form Submissions', group: 'General' },
    { id: 'view-analytics', label: 'View Analytics', group: 'General' },
    { id: 'settings', label: 'Site Settings', group: 'General' },
    { id: 'api-access', label: 'API Access', group: 'General' },
    { id: 'security', label: 'Security', group: 'General' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-xl font-bold">Crystal CMS</h1>
            <button
              onClick={handleLogout}
              className="px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tabs */}
        <div className="mb-8 border-b border-gray-200">
          <nav className="flex space-x-8 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? 'border-black text-black'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow p-6">
          {activeTab === 'photo-settings' && <PhotoSettingsPanel />}
          {activeTab === 'photo-page-content' && <PhotoPageContentPanel />}
          {activeTab === 'collections' && <CollectionsPanel />}
          {activeTab === 'film-settings' && <FilmSettingsPanel />}
          {activeTab === 'film-landing' && <FilmLandingPanel />}
          {activeTab === 'crystal-difference' && <CrystalDifferencePanel />}
          {activeTab === 'services' && <ServicesPanel />}
          {activeTab === 'blog' && <BlogPanel />}
          {activeTab === 'inspo' && <InspoPanel />}
          {activeTab === 'seo-pages' && <SeoPagesPanel />}
          {activeTab === 'vendors' && <VendorsPanel />}
          {activeTab === 'about-settings' && <AboutSettingsPanel />}
          {activeTab === 'testimonials' && <TestimonialsPanel />}
          {activeTab === 'faqs' && <FAQPanel />}
          {activeTab === 'submissions' && <SubmissionsPanel />}
          {activeTab === 'view-analytics' && <ViewAnalyticsPanel />}
          {activeTab === 'settings' && <SettingsPanel />}
          {activeTab === 'api-access' && <ApiAccessPanel />}
          {activeTab === 'security' && <SecurityPanel />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
